import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-crop-dialog',
  standalone: true,
  imports: [],
  templateUrl: './image-crop-dialog.component.html',
  styleUrl: './image-crop-dialog.component.css'
})
export class ImageCropDialogComponent {
  imageChangedEvent: any = '';
  croppedImage: any = '';

  constructor(
    public dialogRef: MatDialogRef<ImageCropDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.imageChangedEvent = data.imageEvent;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  onSave() {
    this.dialogRef.close(this.croppedImage);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
